module.exports = __webpack_public_path__ + "static/35-7c2101828bcccd7d5c0cb318c176d86d.png";